import type { FC } from "react"
import { BrowserRouter, Navigate, Route } from "react-router"
import { AuthenticatedLayout } from "./AuthenticatedLayout"
import { MetaTags } from "./components/MetaTags"
import { TenantAppFrame } from "./components/tenant/tenant-app-frame"
import { TenantPermissionRoute } from "./components/tenant/tenant-permission-route"
import { TenantSettingsLayout } from "./components/tenant/tenant-settings-layout"
import { ErrorPage } from "./ErrorPage"
import { LoggedOutGateLayout } from "./logged-out-gate-layout"
import { LoginLayout } from "./login-layout"
import {
  TenantDashboard,
  TenantEmailNotVerified,
  TenantForgotPassword,
  TenantForgotPasswordSent,
  TenantLogin,
  TenantMemberAdd,
  TenantMemberEdit,
  TenantMembers,
  TenantNotFound,
  TenantResetPassword,
  TenantSales,
  TenantShopSettings,
  TenantSignup,
  TenantSignupInfo,
  TenantTicketCreate,
  TenantTicketDetail,
  TenantTicketEdit,
  TenantTicketList,
  TenantTicketPreview,
  TenantTicketSettings,
} from "./routes"
import { SentryRoutes } from "./sentry"
import { SignupLayout } from "./signup-layout"

export const Routes: FC = () => {
  return (
    <BrowserRouter>
      <MetaTags />
      <SentryRoutes>
        <Route element={<TenantAppFrame />} errorElement={<ErrorPage />}>
          <Route index element={<Navigate to="/login" replace />} />
          <Route path="not-found" element={<TenantNotFound />} />

          <Route element={<LoggedOutGateLayout />}>
            <Route element={<LoginLayout />}>
              <Route path="login" element={<TenantLogin />} />
              <Route path="login/forget-password" element={<TenantForgotPassword />} />
              <Route path="login/forget-password/sent" element={<TenantForgotPasswordSent />} />
              <Route path="login/reset-password" element={<TenantResetPassword />} />
            </Route>

            <Route element={<SignupLayout />}>
              <Route path="signup" element={<TenantSignup />} />
              <Route path="signup/email-not-verified" element={<TenantEmailNotVerified />} />
              <Route path="signup/info" element={<TenantSignupInfo />} />
            </Route>
          </Route>

          <Route element={<AuthenticatedLayout />}>
            <Route path="dashboard" element={<TenantDashboard />} />
            <Route element={<TenantPermissionRoute />}>
              <Route path="tickets">
                <Route index element={<TenantTicketList />} />
                <Route path="add" element={<TenantTicketCreate />} />
                <Route path="preview" element={<TenantTicketPreview />} />
                <Route path=":ticketId" element={<TenantTicketDetail />} />
                <Route path=":ticketId/edit" element={<TenantTicketEdit />} />
              </Route>
              <Route path="sales">
                <Route index element={<TenantSales />} />
              </Route>
              <Route path="setting" element={<TenantSettingsLayout />}>
                <Route path="shop" element={<TenantShopSettings />} />
                <Route path="members">
                  <Route index element={<TenantMembers />} />
                  <Route path="add" element={<TenantMemberAdd />} />
                  <Route path="edit/:memberId" element={<TenantMemberEdit />} />
                </Route>
                <Route path="tickets" element={<TenantTicketSettings />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Route>
      </SentryRoutes>
    </BrowserRouter>
  )
}
